import { render } from "./DashboardCol.vue?vue&type=template&id=c2aba716"
import script from "./DashboardCol.vue?vue&type=script&lang=js"
export * from "./DashboardCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__